export default {
      items:[
            {name:'Home',link:''},
            {name:'Workshops',link:'/workshops'},
            {name:'Events',link:'/tech-nonTech-events'},
            {name:'Contact',link:'/contact/faq'}
      ]
}